import { useEffect } from 'react';

const MAX_TIMEOUT_MS = 2 ** 31 - 1;
const RETRY_DELAYS_MS = [5_000, 15_000, 45_000];

export function useEconomicBillingCycleRenewalRefresh(
  enabled: boolean,
  cycleEndAtMs: number | null,
  refresh: () => Promise<'legacy' | 'economic' | 'unavailable'>
) {
  useEffect(() => {
    if (!enabled || cycleEndAtMs === null || !Number.isFinite(cycleEndAtMs)) return;
    let canceled = false;
    let timer: number;
    let failures = 0;
    const renew = async () => {
      const remaining = cycleEndAtMs - Date.now();
      if (remaining > 0) {
        timer = window.setTimeout(() => { void renew(); }, Math.min(MAX_TIMEOUT_MS, remaining));
        return;
      }
      const result = await refresh();
      if (!canceled && result === 'unavailable' && failures < RETRY_DELAYS_MS.length) {
        timer = window.setTimeout(() => { void renew(); }, RETRY_DELAYS_MS[failures++]);
      }
    };
    // A new server cycle replaces this deadline; failures have bounded retries
    // and can also recover through the existing focus refresh.
    timer = window.setTimeout(() => { void renew(); }, Math.min(MAX_TIMEOUT_MS, Math.max(0, cycleEndAtMs - Date.now())));
    return () => { canceled = true; window.clearTimeout(timer); };
  }, [enabled, cycleEndAtMs, refresh]);
}
